//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.4.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { BaseClient } from './BaseClient';

export class ApiClient extends BaseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiAnswerGet(id: string | undefined, cancelToken?: CancelToken): Promise<Answer> {
        let url_ = this.baseUrl + "/api/Answer/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAnswerGet(_response);
        });
    }

    protected processApiAnswerGet(response: AxiosResponse): Promise<Answer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Answer.fromJS(resultData200);
            return Promise.resolve<Answer>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Answer>(null as any);
    }

    /**
     * @return Success
     */
    apiAnswerGetList( cancelToken?: CancelToken): Promise<Answer[]> {
        let url_ = this.baseUrl + "/api/Answer/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAnswerGetList(_response);
        });
    }

    protected processApiAnswerGetList(response: AxiosResponse): Promise<Answer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Answer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Answer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Answer[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiAnswerGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfAnswer> {
        let url_ = this.baseUrl + "/api/Answer/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAnswerGetPage(_response);
        });
    }

    protected processApiAnswerGetPage(response: AxiosResponse): Promise<PagedResult_1OfAnswer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfAnswer.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfAnswer>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfAnswer>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiAnswerAdd(body: Answer | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Answer/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAnswerAdd(_response);
        });
    }

    protected processApiAnswerAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiAnswerAddRange(body: Answer[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Answer/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAnswerAddRange(_response);
        });
    }

    protected processApiAnswerAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiAnswerUpdate(body: Answer | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Answer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAnswerUpdate(_response);
        });
    }

    protected processApiAnswerUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiAnswerDelete(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Answer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAnswerDelete(_response);
        });
    }

    protected processApiAnswerDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param idQuestionnaire (optional) 
     * @param idEstablishment (optional) 
     * @return Success
     */
    apiAnswerGetListByQuestionnaireAndEstablishment(idQuestionnaire: string | undefined, idEstablishment: string | undefined, cancelToken?: CancelToken): Promise<Answer[]> {
        let url_ = this.baseUrl + "/api/Answer/GetListByQuestionnaireAndEstablishment?";
        if (idQuestionnaire === null)
            throw new Error("The parameter 'idQuestionnaire' cannot be null.");
        else if (idQuestionnaire !== undefined)
            url_ += "idQuestionnaire=" + encodeURIComponent("" + idQuestionnaire) + "&";
        if (idEstablishment === null)
            throw new Error("The parameter 'idEstablishment' cannot be null.");
        else if (idEstablishment !== undefined)
            url_ += "idEstablishment=" + encodeURIComponent("" + idEstablishment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAnswerGetListByQuestionnaireAndEstablishment(_response);
        });
    }

    protected processApiAnswerGetListByQuestionnaireAndEstablishment(response: AxiosResponse): Promise<Answer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Answer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Answer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Answer[]>(null as any);
    }

    /**
     * @param idQuestionnaire (optional) 
     * @return Success
     */
    apiAnswerGetListByQuestionnaire(idQuestionnaire: string | undefined, cancelToken?: CancelToken): Promise<Answer[]> {
        let url_ = this.baseUrl + "/api/Answer/GetListByQuestionnaire?";
        if (idQuestionnaire === null)
            throw new Error("The parameter 'idQuestionnaire' cannot be null.");
        else if (idQuestionnaire !== undefined)
            url_ += "idQuestionnaire=" + encodeURIComponent("" + idQuestionnaire) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAnswerGetListByQuestionnaire(_response);
        });
    }

    protected processApiAnswerGetListByQuestionnaire(response: AxiosResponse): Promise<Answer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Answer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Answer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Answer[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiAuthenticationLogin(body: LoginModel | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Authentication/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthenticationLogin(_response);
        });
    }

    protected processApiAuthenticationLogin(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiAuthenticationRegister(body: RegistrationModel | undefined, cancelToken?: CancelToken): Promise<RegistrationModel> {
        let url_ = this.baseUrl + "/api/Authentication/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthenticationRegister(_response);
        });
    }

    protected processApiAuthenticationRegister(response: AxiosResponse): Promise<RegistrationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = RegistrationModel.fromJS(resultData201);
            return Promise.resolve<RegistrationModel>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationModel>(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    apiAuthenticationGetUserByEmail(email: string | undefined, cancelToken?: CancelToken): Promise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/Authentication/GetUserByEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAuthenticationGetUserByEmail(_response);
        });
    }

    protected processApiAuthenticationGetUserByEmail(response: AxiosResponse): Promise<ApplicationUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationUser.fromJS(resultData200);
            return Promise.resolve<ApplicationUser>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationUser>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiAutonomousRegionGet(id: number | undefined, cancelToken?: CancelToken): Promise<AutonomousRegion> {
        let url_ = this.baseUrl + "/api/AutonomousRegion/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAutonomousRegionGet(_response);
        });
    }

    protected processApiAutonomousRegionGet(response: AxiosResponse): Promise<AutonomousRegion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AutonomousRegion.fromJS(resultData200);
            return Promise.resolve<AutonomousRegion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutonomousRegion>(null as any);
    }

    /**
     * @return Success
     */
    apiAutonomousRegionGetList( cancelToken?: CancelToken): Promise<AutonomousRegion[]> {
        let url_ = this.baseUrl + "/api/AutonomousRegion/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAutonomousRegionGetList(_response);
        });
    }

    protected processApiAutonomousRegionGetList(response: AxiosResponse): Promise<AutonomousRegion[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AutonomousRegion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AutonomousRegion[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutonomousRegion[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiAutonomousRegionGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfAutonomousRegion> {
        let url_ = this.baseUrl + "/api/AutonomousRegion/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAutonomousRegionGetPage(_response);
        });
    }

    protected processApiAutonomousRegionGetPage(response: AxiosResponse): Promise<PagedResult_1OfAutonomousRegion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfAutonomousRegion.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfAutonomousRegion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfAutonomousRegion>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiAutonomousRegionAdd(body: AutonomousRegion | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AutonomousRegion/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAutonomousRegionAdd(_response);
        });
    }

    protected processApiAutonomousRegionAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiAutonomousRegionAddRange(body: AutonomousRegion[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AutonomousRegion/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAutonomousRegionAddRange(_response);
        });
    }

    protected processApiAutonomousRegionAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiAutonomousRegionUpdate(body: AutonomousRegion | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AutonomousRegion/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAutonomousRegionUpdate(_response);
        });
    }

    protected processApiAutonomousRegionUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiAutonomousRegionDelete(id: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/AutonomousRegion/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiAutonomousRegionDelete(_response);
        });
    }

    protected processApiAutonomousRegionDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiEstablishmentGet(id: string | undefined, cancelToken?: CancelToken): Promise<Establishment> {
        let url_ = this.baseUrl + "/api/Establishment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentGet(_response);
        });
    }

    protected processApiEstablishmentGet(response: AxiosResponse): Promise<Establishment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Establishment.fromJS(resultData200);
            return Promise.resolve<Establishment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Establishment>(null as any);
    }

    /**
     * @return Success
     */
    apiEstablishmentGetList( cancelToken?: CancelToken): Promise<Establishment[]> {
        let url_ = this.baseUrl + "/api/Establishment/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentGetList(_response);
        });
    }

    protected processApiEstablishmentGetList(response: AxiosResponse): Promise<Establishment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Establishment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Establishment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Establishment[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiEstablishmentGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfEstablishment> {
        let url_ = this.baseUrl + "/api/Establishment/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentGetPage(_response);
        });
    }

    protected processApiEstablishmentGetPage(response: AxiosResponse): Promise<PagedResult_1OfEstablishment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfEstablishment.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfEstablishment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfEstablishment>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiEstablishmentAdd(body: Establishment | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Establishment/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentAdd(_response);
        });
    }

    protected processApiEstablishmentAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiEstablishmentAddRange(body: Establishment[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Establishment/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentAddRange(_response);
        });
    }

    protected processApiEstablishmentAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiEstablishmentUpdate(body: Establishment | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Establishment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentUpdate(_response);
        });
    }

    protected processApiEstablishmentUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiEstablishmentDelete(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Establishment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentDelete(_response);
        });
    }

    protected processApiEstablishmentDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param idUser (optional) 
     * @return Success
     */
    apiEstablishmentGetEstablishmentByUserId(idUser: string | undefined, cancelToken?: CancelToken): Promise<Establishment> {
        let url_ = this.baseUrl + "/api/Establishment/GetEstablishmentByUserId?";
        if (idUser === null)
            throw new Error("The parameter 'idUser' cannot be null.");
        else if (idUser !== undefined)
            url_ += "idUser=" + encodeURIComponent("" + idUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentGetEstablishmentByUserId(_response);
        });
    }

    protected processApiEstablishmentGetEstablishmentByUserId(response: AxiosResponse): Promise<Establishment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Establishment.fromJS(resultData200);
            return Promise.resolve<Establishment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Establishment>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiEstablishmentTypeGet(id: number | undefined, cancelToken?: CancelToken): Promise<EstablishmentType> {
        let url_ = this.baseUrl + "/api/EstablishmentType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentTypeGet(_response);
        });
    }

    protected processApiEstablishmentTypeGet(response: AxiosResponse): Promise<EstablishmentType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EstablishmentType.fromJS(resultData200);
            return Promise.resolve<EstablishmentType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EstablishmentType>(null as any);
    }

    /**
     * @return Success
     */
    apiEstablishmentTypeGetList( cancelToken?: CancelToken): Promise<EstablishmentType[]> {
        let url_ = this.baseUrl + "/api/EstablishmentType/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentTypeGetList(_response);
        });
    }

    protected processApiEstablishmentTypeGetList(response: AxiosResponse): Promise<EstablishmentType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EstablishmentType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EstablishmentType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EstablishmentType[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiEstablishmentTypeGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfEstablishmentType> {
        let url_ = this.baseUrl + "/api/EstablishmentType/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentTypeGetPage(_response);
        });
    }

    protected processApiEstablishmentTypeGetPage(response: AxiosResponse): Promise<PagedResult_1OfEstablishmentType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfEstablishmentType.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfEstablishmentType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfEstablishmentType>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiEstablishmentTypeAdd(body: EstablishmentType | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EstablishmentType/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentTypeAdd(_response);
        });
    }

    protected processApiEstablishmentTypeAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiEstablishmentTypeAddRange(body: EstablishmentType[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EstablishmentType/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentTypeAddRange(_response);
        });
    }

    protected processApiEstablishmentTypeAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiEstablishmentTypeUpdate(body: EstablishmentType | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EstablishmentType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentTypeUpdate(_response);
        });
    }

    protected processApiEstablishmentTypeUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiEstablishmentTypeDelete(id: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/EstablishmentType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiEstablishmentTypeDelete(_response);
        });
    }

    protected processApiEstablishmentTypeDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiLocalizationGet(id: number | undefined, cancelToken?: CancelToken): Promise<Localization> {
        let url_ = this.baseUrl + "/api/Localization/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiLocalizationGet(_response);
        });
    }

    protected processApiLocalizationGet(response: AxiosResponse): Promise<Localization> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Localization.fromJS(resultData200);
            return Promise.resolve<Localization>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Localization>(null as any);
    }

    /**
     * @return Success
     */
    apiLocalizationGetList( cancelToken?: CancelToken): Promise<Localization[]> {
        let url_ = this.baseUrl + "/api/Localization/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiLocalizationGetList(_response);
        });
    }

    protected processApiLocalizationGetList(response: AxiosResponse): Promise<Localization[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Localization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Localization[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Localization[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiLocalizationGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfLocalization> {
        let url_ = this.baseUrl + "/api/Localization/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiLocalizationGetPage(_response);
        });
    }

    protected processApiLocalizationGetPage(response: AxiosResponse): Promise<PagedResult_1OfLocalization> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfLocalization.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfLocalization>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfLocalization>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiLocalizationAdd(body: Localization | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Localization/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiLocalizationAdd(_response);
        });
    }

    protected processApiLocalizationAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiLocalizationAddRange(body: Localization[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Localization/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiLocalizationAddRange(_response);
        });
    }

    protected processApiLocalizationAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiLocalizationUpdate(body: Localization | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Localization/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiLocalizationUpdate(_response);
        });
    }

    protected processApiLocalizationUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiLocalizationDelete(id: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Localization/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiLocalizationDelete(_response);
        });
    }

    protected processApiLocalizationDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionGet(id: string | undefined, cancelToken?: CancelToken): Promise<Question> {
        let url_ = this.baseUrl + "/api/Question/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionGet(_response);
        });
    }

    protected processApiQuestionGet(response: AxiosResponse): Promise<Question> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Question.fromJS(resultData200);
            return Promise.resolve<Question>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Question>(null as any);
    }

    /**
     * @return Success
     */
    apiQuestionGetList( cancelToken?: CancelToken): Promise<Question[]> {
        let url_ = this.baseUrl + "/api/Question/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionGetList(_response);
        });
    }

    protected processApiQuestionGetList(response: AxiosResponse): Promise<Question[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Question.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Question[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Question[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiQuestionGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfQuestion> {
        let url_ = this.baseUrl + "/api/Question/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionGetPage(_response);
        });
    }

    protected processApiQuestionGetPage(response: AxiosResponse): Promise<PagedResult_1OfQuestion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfQuestion.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfQuestion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfQuestion>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionAdd(body: Question | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Question/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionAdd(_response);
        });
    }

    protected processApiQuestionAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionAddRange(body: Question[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Question/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionAddRange(_response);
        });
    }

    protected processApiQuestionAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionUpdate(body: Question | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Question/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionUpdate(_response);
        });
    }

    protected processApiQuestionUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionDelete(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Question/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionDelete(_response);
        });
    }

    protected processApiQuestionDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionnaireGet(id: string | undefined, cancelToken?: CancelToken): Promise<Questionnaire> {
        let url_ = this.baseUrl + "/api/Questionnaire/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireGet(_response);
        });
    }

    protected processApiQuestionnaireGet(response: AxiosResponse): Promise<Questionnaire> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Questionnaire.fromJS(resultData200);
            return Promise.resolve<Questionnaire>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Questionnaire>(null as any);
    }

    /**
     * @return Success
     */
    apiQuestionnaireGetList( cancelToken?: CancelToken): Promise<Questionnaire[]> {
        let url_ = this.baseUrl + "/api/Questionnaire/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireGetList(_response);
        });
    }

    protected processApiQuestionnaireGetList(response: AxiosResponse): Promise<Questionnaire[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Questionnaire.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Questionnaire[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Questionnaire[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiQuestionnaireGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfQuestionnaire> {
        let url_ = this.baseUrl + "/api/Questionnaire/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireGetPage(_response);
        });
    }

    protected processApiQuestionnaireGetPage(response: AxiosResponse): Promise<PagedResult_1OfQuestionnaire> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfQuestionnaire.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfQuestionnaire>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfQuestionnaire>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireAdd(body: Questionnaire | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Questionnaire/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireAdd(_response);
        });
    }

    protected processApiQuestionnaireAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireAddRange(body: Questionnaire[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Questionnaire/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireAddRange(_response);
        });
    }

    protected processApiQuestionnaireAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireUpdate(body: Questionnaire | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Questionnaire/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireUpdate(_response);
        });
    }

    protected processApiQuestionnaireUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionnaireDelete(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Questionnaire/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireDelete(_response);
        });
    }

    protected processApiQuestionnaireDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionnaireEstablishmentGet(id: string | undefined, cancelToken?: CancelToken): Promise<QuestionnaireEstablishment> {
        let url_ = this.baseUrl + "/api/QuestionnaireEstablishment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireEstablishmentGet(_response);
        });
    }

    protected processApiQuestionnaireEstablishmentGet(response: AxiosResponse): Promise<QuestionnaireEstablishment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionnaireEstablishment.fromJS(resultData200);
            return Promise.resolve<QuestionnaireEstablishment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionnaireEstablishment>(null as any);
    }

    /**
     * @return Success
     */
    apiQuestionnaireEstablishmentGetList( cancelToken?: CancelToken): Promise<QuestionnaireEstablishment[]> {
        let url_ = this.baseUrl + "/api/QuestionnaireEstablishment/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireEstablishmentGetList(_response);
        });
    }

    protected processApiQuestionnaireEstablishmentGetList(response: AxiosResponse): Promise<QuestionnaireEstablishment[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireEstablishment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuestionnaireEstablishment[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionnaireEstablishment[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiQuestionnaireEstablishmentGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfQuestionnaireEstablishment> {
        let url_ = this.baseUrl + "/api/QuestionnaireEstablishment/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireEstablishmentGetPage(_response);
        });
    }

    protected processApiQuestionnaireEstablishmentGetPage(response: AxiosResponse): Promise<PagedResult_1OfQuestionnaireEstablishment> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfQuestionnaireEstablishment.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfQuestionnaireEstablishment>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfQuestionnaireEstablishment>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireEstablishmentAdd(body: QuestionnaireEstablishment | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireEstablishment/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireEstablishmentAdd(_response);
        });
    }

    protected processApiQuestionnaireEstablishmentAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireEstablishmentAddRange(body: QuestionnaireEstablishment[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireEstablishment/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireEstablishmentAddRange(_response);
        });
    }

    protected processApiQuestionnaireEstablishmentAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireEstablishmentUpdate(body: QuestionnaireEstablishment | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireEstablishment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireEstablishmentUpdate(_response);
        });
    }

    protected processApiQuestionnaireEstablishmentUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionnaireEstablishmentDelete(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireEstablishment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireEstablishmentDelete(_response);
        });
    }

    protected processApiQuestionnaireEstablishmentDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionnaireLegendGet(id: string | undefined, cancelToken?: CancelToken): Promise<QuestionnaireLegend> {
        let url_ = this.baseUrl + "/api/QuestionnaireLegend/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireLegendGet(_response);
        });
    }

    protected processApiQuestionnaireLegendGet(response: AxiosResponse): Promise<QuestionnaireLegend> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionnaireLegend.fromJS(resultData200);
            return Promise.resolve<QuestionnaireLegend>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionnaireLegend>(null as any);
    }

    /**
     * @return Success
     */
    apiQuestionnaireLegendGetList( cancelToken?: CancelToken): Promise<QuestionnaireLegend[]> {
        let url_ = this.baseUrl + "/api/QuestionnaireLegend/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireLegendGetList(_response);
        });
    }

    protected processApiQuestionnaireLegendGetList(response: AxiosResponse): Promise<QuestionnaireLegend[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireLegend.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuestionnaireLegend[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionnaireLegend[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiQuestionnaireLegendGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfQuestionnaireLegend> {
        let url_ = this.baseUrl + "/api/QuestionnaireLegend/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireLegendGetPage(_response);
        });
    }

    protected processApiQuestionnaireLegendGetPage(response: AxiosResponse): Promise<PagedResult_1OfQuestionnaireLegend> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfQuestionnaireLegend.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfQuestionnaireLegend>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfQuestionnaireLegend>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireLegendAdd(body: QuestionnaireLegend | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireLegend/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireLegendAdd(_response);
        });
    }

    protected processApiQuestionnaireLegendAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireLegendAddRange(body: QuestionnaireLegend[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireLegend/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireLegendAddRange(_response);
        });
    }

    protected processApiQuestionnaireLegendAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireLegendUpdate(body: QuestionnaireLegend | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireLegend/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireLegendUpdate(_response);
        });
    }

    protected processApiQuestionnaireLegendUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionnaireLegendDelete(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireLegend/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireLegendDelete(_response);
        });
    }

    protected processApiQuestionnaireLegendDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionnaireSectionGet(id: string | undefined, cancelToken?: CancelToken): Promise<QuestionnaireSection> {
        let url_ = this.baseUrl + "/api/QuestionnaireSection/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireSectionGet(_response);
        });
    }

    protected processApiQuestionnaireSectionGet(response: AxiosResponse): Promise<QuestionnaireSection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionnaireSection.fromJS(resultData200);
            return Promise.resolve<QuestionnaireSection>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionnaireSection>(null as any);
    }

    /**
     * @return Success
     */
    apiQuestionnaireSectionGetList( cancelToken?: CancelToken): Promise<QuestionnaireSection[]> {
        let url_ = this.baseUrl + "/api/QuestionnaireSection/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireSectionGetList(_response);
        });
    }

    protected processApiQuestionnaireSectionGetList(response: AxiosResponse): Promise<QuestionnaireSection[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireSection.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuestionnaireSection[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionnaireSection[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiQuestionnaireSectionGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfQuestionnaireSection> {
        let url_ = this.baseUrl + "/api/QuestionnaireSection/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireSectionGetPage(_response);
        });
    }

    protected processApiQuestionnaireSectionGetPage(response: AxiosResponse): Promise<PagedResult_1OfQuestionnaireSection> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfQuestionnaireSection.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfQuestionnaireSection>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfQuestionnaireSection>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireSectionAdd(body: QuestionnaireSection | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireSection/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireSectionAdd(_response);
        });
    }

    protected processApiQuestionnaireSectionAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireSectionAddRange(body: QuestionnaireSection[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireSection/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireSectionAddRange(_response);
        });
    }

    protected processApiQuestionnaireSectionAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionnaireSectionUpdate(body: QuestionnaireSection | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireSection/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireSectionUpdate(_response);
        });
    }

    protected processApiQuestionnaireSectionUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionnaireSectionDelete(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionnaireSection/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionnaireSectionDelete(_response);
        });
    }

    protected processApiQuestionnaireSectionDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionTypeGet(id: number | undefined, cancelToken?: CancelToken): Promise<QuestionType> {
        let url_ = this.baseUrl + "/api/QuestionType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionTypeGet(_response);
        });
    }

    protected processApiQuestionTypeGet(response: AxiosResponse): Promise<QuestionType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionType.fromJS(resultData200);
            return Promise.resolve<QuestionType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionType>(null as any);
    }

    /**
     * @return Success
     */
    apiQuestionTypeGetList( cancelToken?: CancelToken): Promise<QuestionType[]> {
        let url_ = this.baseUrl + "/api/QuestionType/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionTypeGetList(_response);
        });
    }

    protected processApiQuestionTypeGetList(response: AxiosResponse): Promise<QuestionType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<QuestionType[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionType[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiQuestionTypeGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfQuestionType> {
        let url_ = this.baseUrl + "/api/QuestionType/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionTypeGetPage(_response);
        });
    }

    protected processApiQuestionTypeGetPage(response: AxiosResponse): Promise<PagedResult_1OfQuestionType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfQuestionType.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfQuestionType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfQuestionType>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionTypeAdd(body: QuestionType | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionType/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionTypeAdd(_response);
        });
    }

    protected processApiQuestionTypeAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionTypeAddRange(body: QuestionType[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionType/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionTypeAddRange(_response);
        });
    }

    protected processApiQuestionTypeAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiQuestionTypeUpdate(body: QuestionType | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionTypeUpdate(_response);
        });
    }

    protected processApiQuestionTypeUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiQuestionTypeDelete(id: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/QuestionType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiQuestionTypeDelete(_response);
        });
    }

    protected processApiQuestionTypeDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiSustainabilityMemoryGet(id: string | undefined, cancelToken?: CancelToken): Promise<SustainabilityMemory> {
        let url_ = this.baseUrl + "/api/SustainabilityMemory/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiSustainabilityMemoryGet(_response);
        });
    }

    protected processApiSustainabilityMemoryGet(response: AxiosResponse): Promise<SustainabilityMemory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SustainabilityMemory.fromJS(resultData200);
            return Promise.resolve<SustainabilityMemory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SustainabilityMemory>(null as any);
    }

    /**
     * @return Success
     */
    apiSustainabilityMemoryGetList( cancelToken?: CancelToken): Promise<SustainabilityMemory[]> {
        let url_ = this.baseUrl + "/api/SustainabilityMemory/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiSustainabilityMemoryGetList(_response);
        });
    }

    protected processApiSustainabilityMemoryGetList(response: AxiosResponse): Promise<SustainabilityMemory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SustainabilityMemory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SustainabilityMemory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SustainabilityMemory[]>(null as any);
    }

    /**
     * @param pageNum (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    apiSustainabilityMemoryGetPage(pageNum: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<PagedResult_1OfSustainabilityMemory> {
        let url_ = this.baseUrl + "/api/SustainabilityMemory/GetPage?";
        if (pageNum === null)
            throw new Error("The parameter 'pageNum' cannot be null.");
        else if (pageNum !== undefined)
            url_ += "PageNum=" + encodeURIComponent("" + pageNum) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiSustainabilityMemoryGetPage(_response);
        });
    }

    protected processApiSustainabilityMemoryGetPage(response: AxiosResponse): Promise<PagedResult_1OfSustainabilityMemory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResult_1OfSustainabilityMemory.fromJS(resultData200);
            return Promise.resolve<PagedResult_1OfSustainabilityMemory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResult_1OfSustainabilityMemory>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiSustainabilityMemoryAdd(body: SustainabilityMemory | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SustainabilityMemory/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiSustainabilityMemoryAdd(_response);
        });
    }

    protected processApiSustainabilityMemoryAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiSustainabilityMemoryAddRange(body: SustainabilityMemory[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SustainabilityMemory/AddRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiSustainabilityMemoryAddRange(_response);
        });
    }

    protected processApiSustainabilityMemoryAddRange(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiSustainabilityMemoryUpdate(body: SustainabilityMemory | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SustainabilityMemory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiSustainabilityMemoryUpdate(_response);
        });
    }

    protected processApiSustainabilityMemoryUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    apiSustainabilityMemoryDelete(id: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SustainabilityMemory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiSustainabilityMemoryDelete(_response);
        });
    }

    protected processApiSustainabilityMemoryDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    apiSustainabilityMemoryDownloadSustainabilityMemory( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SustainabilityMemory/DownloadSustainabilityMemory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiSustainabilityMemoryDownloadSustainabilityMemory(_response);
        });
    }

    protected processApiSustainabilityMemoryDownloadSustainabilityMemory(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ApplicationUser implements IApplicationUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;

    constructor(data?: IApplicationUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["role"] = this.role;
        return data;
    }
}

export interface IApplicationUser {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;
}

export class LoginModel implements ILoginModel {
    username!: string;
    password!: string;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginModel {
    username: string;
    password: string;
}

export class RegistrationModel implements IRegistrationModel {
    firstName!: string;
    lastName?: string | undefined;
    email!: string;
    phoneNumber?: string | undefined;
    password!: string;

    constructor(data?: IRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): RegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        return data;
    }
}

export interface IRegistrationModel {
    firstName: string;
    lastName?: string | undefined;
    email: string;
    phoneNumber?: string | undefined;
    password: string;
}

export class PagedResult_1OfAnswer implements IPagedResult_1OfAnswer {
    total?: number;
    data?: Answer[] | undefined;

    constructor(data?: IPagedResult_1OfAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Answer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfAnswer {
    total?: number;
    data?: Answer[] | undefined;
}

export class PagedResult_1OfAutonomousRegion implements IPagedResult_1OfAutonomousRegion {
    total?: number;
    data?: AutonomousRegion[] | undefined;

    constructor(data?: IPagedResult_1OfAutonomousRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AutonomousRegion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfAutonomousRegion {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfAutonomousRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfAutonomousRegion {
    total?: number;
    data?: AutonomousRegion[] | undefined;
}

export class PagedResult_1OfEstablishmentType implements IPagedResult_1OfEstablishmentType {
    total?: number;
    data?: EstablishmentType[] | undefined;

    constructor(data?: IPagedResult_1OfEstablishmentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EstablishmentType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfEstablishmentType {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfEstablishmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfEstablishmentType {
    total?: number;
    data?: EstablishmentType[] | undefined;
}

export class PagedResult_1OfEstablishment implements IPagedResult_1OfEstablishment {
    total?: number;
    data?: Establishment[] | undefined;

    constructor(data?: IPagedResult_1OfEstablishment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Establishment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfEstablishment {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfEstablishment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfEstablishment {
    total?: number;
    data?: Establishment[] | undefined;
}

export class PagedResult_1OfLocalization implements IPagedResult_1OfLocalization {
    total?: number;
    data?: Localization[] | undefined;

    constructor(data?: IPagedResult_1OfLocalization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Localization.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfLocalization {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfLocalization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfLocalization {
    total?: number;
    data?: Localization[] | undefined;
}

export class PagedResult_1OfQuestionType implements IPagedResult_1OfQuestionType {
    total?: number;
    data?: QuestionType[] | undefined;

    constructor(data?: IPagedResult_1OfQuestionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuestionType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfQuestionType {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfQuestionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfQuestionType {
    total?: number;
    data?: QuestionType[] | undefined;
}

export class PagedResult_1OfQuestion implements IPagedResult_1OfQuestion {
    total?: number;
    data?: Question[] | undefined;

    constructor(data?: IPagedResult_1OfQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfQuestion {
    total?: number;
    data?: Question[] | undefined;
}

export class PagedResult_1OfQuestionnaireEstablishment implements IPagedResult_1OfQuestionnaireEstablishment {
    total?: number;
    data?: QuestionnaireEstablishment[] | undefined;

    constructor(data?: IPagedResult_1OfQuestionnaireEstablishment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuestionnaireEstablishment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfQuestionnaireEstablishment {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfQuestionnaireEstablishment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfQuestionnaireEstablishment {
    total?: number;
    data?: QuestionnaireEstablishment[] | undefined;
}

export class PagedResult_1OfQuestionnaireLegend implements IPagedResult_1OfQuestionnaireLegend {
    total?: number;
    data?: QuestionnaireLegend[] | undefined;

    constructor(data?: IPagedResult_1OfQuestionnaireLegend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuestionnaireLegend.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfQuestionnaireLegend {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfQuestionnaireLegend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfQuestionnaireLegend {
    total?: number;
    data?: QuestionnaireLegend[] | undefined;
}

export class PagedResult_1OfQuestionnaireSection implements IPagedResult_1OfQuestionnaireSection {
    total?: number;
    data?: QuestionnaireSection[] | undefined;

    constructor(data?: IPagedResult_1OfQuestionnaireSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuestionnaireSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfQuestionnaireSection {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfQuestionnaireSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfQuestionnaireSection {
    total?: number;
    data?: QuestionnaireSection[] | undefined;
}

export class PagedResult_1OfQuestionnaire implements IPagedResult_1OfQuestionnaire {
    total?: number;
    data?: Questionnaire[] | undefined;

    constructor(data?: IPagedResult_1OfQuestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Questionnaire.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfQuestionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfQuestionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfQuestionnaire {
    total?: number;
    data?: Questionnaire[] | undefined;
}

export class PagedResult_1OfSustainabilityMemory implements IPagedResult_1OfSustainabilityMemory {
    total?: number;
    data?: SustainabilityMemory[] | undefined;

    constructor(data?: IPagedResult_1OfSustainabilityMemory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SustainabilityMemory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResult_1OfSustainabilityMemory {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult_1OfSustainabilityMemory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResult_1OfSustainabilityMemory {
    total?: number;
    data?: SustainabilityMemory[] | undefined;
}

export class Answer implements IAnswer {
    id!: string;
    idQuestion?: string;
    idQuestionnaire?: string;
    idEstablishment?: string;
    answerQuestion?: Question;
    answerQuestionnaire?: Questionnaire;
    answerEstablishment?: Establishment;
    value?: number;

    constructor(data?: IAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idQuestion = _data["idQuestion"];
            this.idQuestionnaire = _data["idQuestionnaire"];
            this.idEstablishment = _data["idEstablishment"];
            this.answerQuestion = _data["answerQuestion"] ? Question.fromJS(_data["answerQuestion"]) : <any>undefined;
            this.answerQuestionnaire = _data["answerQuestionnaire"] ? Questionnaire.fromJS(_data["answerQuestionnaire"]) : <any>undefined;
            this.answerEstablishment = _data["answerEstablishment"] ? Establishment.fromJS(_data["answerEstablishment"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Answer {
        data = typeof data === 'object' ? data : {};
        let result = new Answer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idQuestion"] = this.idQuestion;
        data["idQuestionnaire"] = this.idQuestionnaire;
        data["idEstablishment"] = this.idEstablishment;
        data["answerQuestion"] = this.answerQuestion ? this.answerQuestion.toJSON() : <any>undefined;
        data["answerQuestionnaire"] = this.answerQuestionnaire ? this.answerQuestionnaire.toJSON() : <any>undefined;
        data["answerEstablishment"] = this.answerEstablishment ? this.answerEstablishment.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IAnswer {
    id: string;
    idQuestion?: string;
    idQuestionnaire?: string;
    idEstablishment?: string;
    answerQuestion?: Question;
    answerQuestionnaire?: Questionnaire;
    answerEstablishment?: Establishment;
    value?: number;
}

export class AspNetRoleClaims implements IAspNetRoleClaims {
    id!: number;
    roleId?: string | undefined;
    role?: AspNetRoles;
    claimType?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IAspNetRoleClaims) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? AspNetRoles.fromJS(_data["role"]) : <any>undefined;
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): AspNetRoleClaims {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetRoleClaims();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

export interface IAspNetRoleClaims {
    id: number;
    roleId?: string | undefined;
    role?: AspNetRoles;
    claimType?: string | undefined;
    claimValue?: string | undefined;
}

export class AspNetRoles implements IAspNetRoles {
    id!: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
    aspNetRoleClaimss?: AspNetRoleClaims[] | undefined;
    users?: AspNetUsers[] | undefined;
    usersMaps?: AspNetUserRoles[] | undefined;

    constructor(data?: IAspNetRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["aspNetRoleClaimss"])) {
                this.aspNetRoleClaimss = [] as any;
                for (let item of _data["aspNetRoleClaimss"])
                    this.aspNetRoleClaimss!.push(AspNetRoleClaims.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AspNetUsers.fromJS(item));
            }
            if (Array.isArray(_data["usersMaps"])) {
                this.usersMaps = [] as any;
                for (let item of _data["usersMaps"])
                    this.usersMaps!.push(AspNetUserRoles.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AspNetRoles {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetRoles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.aspNetRoleClaimss)) {
            data["aspNetRoleClaimss"] = [];
            for (let item of this.aspNetRoleClaimss)
                data["aspNetRoleClaimss"].push(item.toJSON());
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.usersMaps)) {
            data["usersMaps"] = [];
            for (let item of this.usersMaps)
                data["usersMaps"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAspNetRoles {
    id: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
    aspNetRoleClaimss?: AspNetRoleClaims[] | undefined;
    users?: AspNetUsers[] | undefined;
    usersMaps?: AspNetUserRoles[] | undefined;
}

export class AspNetUserRoles implements IAspNetUserRoles {
    userId?: string | undefined;
    roleId?: string | undefined;

    constructor(data?: IAspNetUserRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): AspNetUserRoles {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserRoles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IAspNetUserRoles {
    userId?: string | undefined;
    roleId?: string | undefined;
}

export class AspNetUserClaims implements IAspNetUserClaims {
    id!: number;
    userId?: string | undefined;
    user?: AspNetUsers;
    claimType?: string | undefined;
    claimValue?: string | undefined;

    constructor(data?: IAspNetUserClaims) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? AspNetUsers.fromJS(_data["user"]) : <any>undefined;
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): AspNetUserClaims {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserClaims();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }
}

export interface IAspNetUserClaims {
    id: number;
    userId?: string | undefined;
    user?: AspNetUsers;
    claimType?: string | undefined;
    claimValue?: string | undefined;
}

export class AspNetUserLogins implements IAspNetUserLogins {
    loginProvider!: string;
    userId?: string | undefined;
    providerKey!: string;
    providerDisplayName?: string | undefined;
    user?: AspNetUsers;

    constructor(data?: IAspNetUserLogins) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginProvider = _data["loginProvider"];
            this.userId = _data["userId"];
            this.providerKey = _data["providerKey"];
            this.providerDisplayName = _data["providerDisplayName"];
            this.user = _data["user"] ? AspNetUsers.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AspNetUserLogins {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserLogins();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginProvider"] = this.loginProvider;
        data["userId"] = this.userId;
        data["providerKey"] = this.providerKey;
        data["providerDisplayName"] = this.providerDisplayName;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAspNetUserLogins {
    loginProvider: string;
    userId?: string | undefined;
    providerKey: string;
    providerDisplayName?: string | undefined;
    user?: AspNetUsers;
}

export class AspNetUserTokens implements IAspNetUserTokens {
    user?: AspNetUsers;
    userId?: string | undefined;
    loginProvider!: string;
    name!: string;
    value?: string | undefined;

    constructor(data?: IAspNetUserTokens) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? AspNetUsers.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AspNetUserTokens {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUserTokens();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IAspNetUserTokens {
    user?: AspNetUsers;
    userId?: string | undefined;
    loginProvider: string;
    name: string;
    value?: string | undefined;
}

export class AspNetUsers implements IAspNetUsers {
    id!: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    aspNetUserClaimss?: AspNetUserClaims[] | undefined;
    aspNetUserLoginss?: AspNetUserLogins[] | undefined;
    roles?: AspNetRoles[] | undefined;
    rolesMaps?: AspNetUserRoles[] | undefined;
    aspNetUserTokenss?: AspNetUserTokens[] | undefined;
    establishmentAspNetUserss?: Establishment[] | undefined;

    constructor(data?: IAspNetUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["aspNetUserClaimss"])) {
                this.aspNetUserClaimss = [] as any;
                for (let item of _data["aspNetUserClaimss"])
                    this.aspNetUserClaimss!.push(AspNetUserClaims.fromJS(item));
            }
            if (Array.isArray(_data["aspNetUserLoginss"])) {
                this.aspNetUserLoginss = [] as any;
                for (let item of _data["aspNetUserLoginss"])
                    this.aspNetUserLoginss!.push(AspNetUserLogins.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(AspNetRoles.fromJS(item));
            }
            if (Array.isArray(_data["rolesMaps"])) {
                this.rolesMaps = [] as any;
                for (let item of _data["rolesMaps"])
                    this.rolesMaps!.push(AspNetUserRoles.fromJS(item));
            }
            if (Array.isArray(_data["aspNetUserTokenss"])) {
                this.aspNetUserTokenss = [] as any;
                for (let item of _data["aspNetUserTokenss"])
                    this.aspNetUserTokenss!.push(AspNetUserTokens.fromJS(item));
            }
            if (Array.isArray(_data["establishmentAspNetUserss"])) {
                this.establishmentAspNetUserss = [] as any;
                for (let item of _data["establishmentAspNetUserss"])
                    this.establishmentAspNetUserss!.push(Establishment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AspNetUsers {
        data = typeof data === 'object' ? data : {};
        let result = new AspNetUsers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.aspNetUserClaimss)) {
            data["aspNetUserClaimss"] = [];
            for (let item of this.aspNetUserClaimss)
                data["aspNetUserClaimss"].push(item.toJSON());
        }
        if (Array.isArray(this.aspNetUserLoginss)) {
            data["aspNetUserLoginss"] = [];
            for (let item of this.aspNetUserLoginss)
                data["aspNetUserLoginss"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.rolesMaps)) {
            data["rolesMaps"] = [];
            for (let item of this.rolesMaps)
                data["rolesMaps"].push(item.toJSON());
        }
        if (Array.isArray(this.aspNetUserTokenss)) {
            data["aspNetUserTokenss"] = [];
            for (let item of this.aspNetUserTokenss)
                data["aspNetUserTokenss"].push(item.toJSON());
        }
        if (Array.isArray(this.establishmentAspNetUserss)) {
            data["establishmentAspNetUserss"] = [];
            for (let item of this.establishmentAspNetUserss)
                data["establishmentAspNetUserss"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAspNetUsers {
    id: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    aspNetUserClaimss?: AspNetUserClaims[] | undefined;
    aspNetUserLoginss?: AspNetUserLogins[] | undefined;
    roles?: AspNetRoles[] | undefined;
    rolesMaps?: AspNetUserRoles[] | undefined;
    aspNetUserTokenss?: AspNetUserTokens[] | undefined;
    establishmentAspNetUserss?: Establishment[] | undefined;
}

export class AutonomousRegion implements IAutonomousRegion {
    id!: number;
    name?: string | undefined;
    establishmentAutonomousRegions?: Establishment[] | undefined;

    constructor(data?: IAutonomousRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["establishmentAutonomousRegions"])) {
                this.establishmentAutonomousRegions = [] as any;
                for (let item of _data["establishmentAutonomousRegions"])
                    this.establishmentAutonomousRegions!.push(Establishment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutonomousRegion {
        data = typeof data === 'object' ? data : {};
        let result = new AutonomousRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.establishmentAutonomousRegions)) {
            data["establishmentAutonomousRegions"] = [];
            for (let item of this.establishmentAutonomousRegions)
                data["establishmentAutonomousRegions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAutonomousRegion {
    id: number;
    name?: string | undefined;
    establishmentAutonomousRegions?: Establishment[] | undefined;
}

export class Establishment implements IEstablishment {
    id!: string;
    idUser?: string | undefined;
    idAutonomousRegion?: number;
    idEstablishmentType?: number;
    idLocalization?: number;
    establishmentAspNetUsers?: AspNetUsers;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactPosition?: string | undefined;
    establishmentAutonomousRegion?: AutonomousRegion;
    ithPartner?: boolean;
    lopd?: boolean;
    establishmentEstablishmentType?: EstablishmentType;
    establishmentLocalization?: Localization;
    name?: string | undefined;
    adress?: string | undefined;
    phoneMobile?: string | undefined;
    phone?: string | undefined;
    city?: string | undefined;
    answers?: Answer[] | undefined;
    questionnaireEstablishments?: QuestionnaireEstablishment[] | undefined;
    sustainabilityMemories?: SustainabilityMemory[] | undefined;

    constructor(data?: IEstablishment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idUser = _data["idUser"];
            this.idAutonomousRegion = _data["idAutonomousRegion"];
            this.idEstablishmentType = _data["idEstablishmentType"];
            this.idLocalization = _data["idLocalization"];
            this.establishmentAspNetUsers = _data["establishmentAspNetUsers"] ? AspNetUsers.fromJS(_data["establishmentAspNetUsers"]) : <any>undefined;
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPosition = _data["contactPosition"];
            this.establishmentAutonomousRegion = _data["establishmentAutonomousRegion"] ? AutonomousRegion.fromJS(_data["establishmentAutonomousRegion"]) : <any>undefined;
            this.ithPartner = _data["ithPartner"];
            this.lopd = _data["lopd"];
            this.establishmentEstablishmentType = _data["establishmentEstablishmentType"] ? EstablishmentType.fromJS(_data["establishmentEstablishmentType"]) : <any>undefined;
            this.establishmentLocalization = _data["establishmentLocalization"] ? Localization.fromJS(_data["establishmentLocalization"]) : <any>undefined;
            this.name = _data["name"];
            this.adress = _data["adress"];
            this.phoneMobile = _data["phoneMobile"];
            this.phone = _data["phone"];
            this.city = _data["city"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(Answer.fromJS(item));
            }
            if (Array.isArray(_data["questionnaireEstablishments"])) {
                this.questionnaireEstablishments = [] as any;
                for (let item of _data["questionnaireEstablishments"])
                    this.questionnaireEstablishments!.push(QuestionnaireEstablishment.fromJS(item));
            }
            if (Array.isArray(_data["sustainabilityMemories"])) {
                this.sustainabilityMemories = [] as any;
                for (let item of _data["sustainabilityMemories"])
                    this.sustainabilityMemories!.push(SustainabilityMemory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Establishment {
        data = typeof data === 'object' ? data : {};
        let result = new Establishment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idUser"] = this.idUser;
        data["idAutonomousRegion"] = this.idAutonomousRegion;
        data["idEstablishmentType"] = this.idEstablishmentType;
        data["idLocalization"] = this.idLocalization;
        data["establishmentAspNetUsers"] = this.establishmentAspNetUsers ? this.establishmentAspNetUsers.toJSON() : <any>undefined;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPosition"] = this.contactPosition;
        data["establishmentAutonomousRegion"] = this.establishmentAutonomousRegion ? this.establishmentAutonomousRegion.toJSON() : <any>undefined;
        data["ithPartner"] = this.ithPartner;
        data["lopd"] = this.lopd;
        data["establishmentEstablishmentType"] = this.establishmentEstablishmentType ? this.establishmentEstablishmentType.toJSON() : <any>undefined;
        data["establishmentLocalization"] = this.establishmentLocalization ? this.establishmentLocalization.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["adress"] = this.adress;
        data["phoneMobile"] = this.phoneMobile;
        data["phone"] = this.phone;
        data["city"] = this.city;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.questionnaireEstablishments)) {
            data["questionnaireEstablishments"] = [];
            for (let item of this.questionnaireEstablishments)
                data["questionnaireEstablishments"].push(item.toJSON());
        }
        if (Array.isArray(this.sustainabilityMemories)) {
            data["sustainabilityMemories"] = [];
            for (let item of this.sustainabilityMemories)
                data["sustainabilityMemories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEstablishment {
    id: string;
    idUser?: string | undefined;
    idAutonomousRegion?: number;
    idEstablishmentType?: number;
    idLocalization?: number;
    establishmentAspNetUsers?: AspNetUsers;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactPosition?: string | undefined;
    establishmentAutonomousRegion?: AutonomousRegion;
    ithPartner?: boolean;
    lopd?: boolean;
    establishmentEstablishmentType?: EstablishmentType;
    establishmentLocalization?: Localization;
    name?: string | undefined;
    adress?: string | undefined;
    phoneMobile?: string | undefined;
    phone?: string | undefined;
    city?: string | undefined;
    answers?: Answer[] | undefined;
    questionnaireEstablishments?: QuestionnaireEstablishment[] | undefined;
    sustainabilityMemories?: SustainabilityMemory[] | undefined;
}

export class EstablishmentType implements IEstablishmentType {
    id!: number;
    name?: string | undefined;
    establishmentEstablishmentTypes?: Establishment[] | undefined;

    constructor(data?: IEstablishmentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["establishmentEstablishmentTypes"])) {
                this.establishmentEstablishmentTypes = [] as any;
                for (let item of _data["establishmentEstablishmentTypes"])
                    this.establishmentEstablishmentTypes!.push(Establishment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EstablishmentType {
        data = typeof data === 'object' ? data : {};
        let result = new EstablishmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.establishmentEstablishmentTypes)) {
            data["establishmentEstablishmentTypes"] = [];
            for (let item of this.establishmentEstablishmentTypes)
                data["establishmentEstablishmentTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEstablishmentType {
    id: number;
    name?: string | undefined;
    establishmentEstablishmentTypes?: Establishment[] | undefined;
}

export class Localization implements ILocalization {
    id!: number;
    name?: string | undefined;
    establishmentLocalizations?: Establishment[] | undefined;

    constructor(data?: ILocalization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["establishmentLocalizations"])) {
                this.establishmentLocalizations = [] as any;
                for (let item of _data["establishmentLocalizations"])
                    this.establishmentLocalizations!.push(Establishment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Localization {
        data = typeof data === 'object' ? data : {};
        let result = new Localization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.establishmentLocalizations)) {
            data["establishmentLocalizations"] = [];
            for (let item of this.establishmentLocalizations)
                data["establishmentLocalizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalization {
    id: number;
    name?: string | undefined;
    establishmentLocalizations?: Establishment[] | undefined;
}

export class Question implements IQuestion {
    id!: string;
    idQuestionnaire?: string;
    idQuestionnaireSection?: string;
    idQuestionType?: number;
    idParentQuestion?: string | undefined;
    idQuestionInfo?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    questionQuestionnaire?: Questionnaire;
    questionQuestionnaireSection?: QuestionnaireSection;
    questionQuestionType?: QuestionType;
    questionQuestion?: Question;
    value?: number | undefined;
    necessaryCriteria?: boolean;
    questionQuestionInfo?: QuestionInfo;
    answers?: Answer[] | undefined;
    questionQuestions?: Question[] | undefined;
    questionQuestionnaireLegends?: QuestionQuestionnaireLegend[] | undefined;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idQuestionnaire = _data["idQuestionnaire"];
            this.idQuestionnaireSection = _data["idQuestionnaireSection"];
            this.idQuestionType = _data["idQuestionType"];
            this.idParentQuestion = _data["idParentQuestion"];
            this.idQuestionInfo = _data["idQuestionInfo"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.questionQuestionnaire = _data["questionQuestionnaire"] ? Questionnaire.fromJS(_data["questionQuestionnaire"]) : <any>undefined;
            this.questionQuestionnaireSection = _data["questionQuestionnaireSection"] ? QuestionnaireSection.fromJS(_data["questionQuestionnaireSection"]) : <any>undefined;
            this.questionQuestionType = _data["questionQuestionType"] ? QuestionType.fromJS(_data["questionQuestionType"]) : <any>undefined;
            this.questionQuestion = _data["questionQuestion"] ? Question.fromJS(_data["questionQuestion"]) : <any>undefined;
            this.value = _data["value"];
            this.necessaryCriteria = _data["necessaryCriteria"];
            this.questionQuestionInfo = _data["questionQuestionInfo"] ? QuestionInfo.fromJS(_data["questionQuestionInfo"]) : <any>undefined;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(Answer.fromJS(item));
            }
            if (Array.isArray(_data["questionQuestions"])) {
                this.questionQuestions = [] as any;
                for (let item of _data["questionQuestions"])
                    this.questionQuestions!.push(Question.fromJS(item));
            }
            if (Array.isArray(_data["questionQuestionnaireLegends"])) {
                this.questionQuestionnaireLegends = [] as any;
                for (let item of _data["questionQuestionnaireLegends"])
                    this.questionQuestionnaireLegends!.push(QuestionQuestionnaireLegend.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idQuestionnaire"] = this.idQuestionnaire;
        data["idQuestionnaireSection"] = this.idQuestionnaireSection;
        data["idQuestionType"] = this.idQuestionType;
        data["idParentQuestion"] = this.idParentQuestion;
        data["idQuestionInfo"] = this.idQuestionInfo;
        data["title"] = this.title;
        data["body"] = this.body;
        data["questionQuestionnaire"] = this.questionQuestionnaire ? this.questionQuestionnaire.toJSON() : <any>undefined;
        data["questionQuestionnaireSection"] = this.questionQuestionnaireSection ? this.questionQuestionnaireSection.toJSON() : <any>undefined;
        data["questionQuestionType"] = this.questionQuestionType ? this.questionQuestionType.toJSON() : <any>undefined;
        data["questionQuestion"] = this.questionQuestion ? this.questionQuestion.toJSON() : <any>undefined;
        data["value"] = this.value;
        data["necessaryCriteria"] = this.necessaryCriteria;
        data["questionQuestionInfo"] = this.questionQuestionInfo ? this.questionQuestionInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.questionQuestions)) {
            data["questionQuestions"] = [];
            for (let item of this.questionQuestions)
                data["questionQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.questionQuestionnaireLegends)) {
            data["questionQuestionnaireLegends"] = [];
            for (let item of this.questionQuestionnaireLegends)
                data["questionQuestionnaireLegends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestion {
    id: string;
    idQuestionnaire?: string;
    idQuestionnaireSection?: string;
    idQuestionType?: number;
    idParentQuestion?: string | undefined;
    idQuestionInfo?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    questionQuestionnaire?: Questionnaire;
    questionQuestionnaireSection?: QuestionnaireSection;
    questionQuestionType?: QuestionType;
    questionQuestion?: Question;
    value?: number | undefined;
    necessaryCriteria?: boolean;
    questionQuestionInfo?: QuestionInfo;
    answers?: Answer[] | undefined;
    questionQuestions?: Question[] | undefined;
    questionQuestionnaireLegends?: QuestionQuestionnaireLegend[] | undefined;
}

export class QuestionInfo implements IQuestionInfo {
    id!: string;
    title?: string | undefined;
    body?: string | undefined;
    questionQuestionInfoes?: Question[] | undefined;

    constructor(data?: IQuestionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.body = _data["body"];
            if (Array.isArray(_data["questionQuestionInfoes"])) {
                this.questionQuestionInfoes = [] as any;
                for (let item of _data["questionQuestionInfoes"])
                    this.questionQuestionInfoes!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["body"] = this.body;
        if (Array.isArray(this.questionQuestionInfoes)) {
            data["questionQuestionInfoes"] = [];
            for (let item of this.questionQuestionInfoes)
                data["questionQuestionInfoes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionInfo {
    id: string;
    title?: string | undefined;
    body?: string | undefined;
    questionQuestionInfoes?: Question[] | undefined;
}

export class QuestionQuestionnaireLegend implements IQuestionQuestionnaireLegend {
    id!: string;
    idQuestion?: string;
    idQuestionnaireLegend?: string;
    questionQuestionnaireLegendQuestion?: Question;
    questionQuestionnaireLegendQuestionnaireLegend?: QuestionnaireLegend;

    constructor(data?: IQuestionQuestionnaireLegend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idQuestion = _data["idQuestion"];
            this.idQuestionnaireLegend = _data["idQuestionnaireLegend"];
            this.questionQuestionnaireLegendQuestion = _data["questionQuestionnaireLegendQuestion"] ? Question.fromJS(_data["questionQuestionnaireLegendQuestion"]) : <any>undefined;
            this.questionQuestionnaireLegendQuestionnaireLegend = _data["questionQuestionnaireLegendQuestionnaireLegend"] ? QuestionnaireLegend.fromJS(_data["questionQuestionnaireLegendQuestionnaireLegend"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionQuestionnaireLegend {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionQuestionnaireLegend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idQuestion"] = this.idQuestion;
        data["idQuestionnaireLegend"] = this.idQuestionnaireLegend;
        data["questionQuestionnaireLegendQuestion"] = this.questionQuestionnaireLegendQuestion ? this.questionQuestionnaireLegendQuestion.toJSON() : <any>undefined;
        data["questionQuestionnaireLegendQuestionnaireLegend"] = this.questionQuestionnaireLegendQuestionnaireLegend ? this.questionQuestionnaireLegendQuestionnaireLegend.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuestionQuestionnaireLegend {
    id: string;
    idQuestion?: string;
    idQuestionnaireLegend?: string;
    questionQuestionnaireLegendQuestion?: Question;
    questionQuestionnaireLegendQuestionnaireLegend?: QuestionnaireLegend;
}

export class QuestionType implements IQuestionType {
    id!: number;
    name?: string | undefined;
    questionQuestionTypes?: Question[] | undefined;

    constructor(data?: IQuestionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["questionQuestionTypes"])) {
                this.questionQuestionTypes = [] as any;
                for (let item of _data["questionQuestionTypes"])
                    this.questionQuestionTypes!.push(Question.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionType {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.questionQuestionTypes)) {
            data["questionQuestionTypes"] = [];
            for (let item of this.questionQuestionTypes)
                data["questionQuestionTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionType {
    id: number;
    name?: string | undefined;
    questionQuestionTypes?: Question[] | undefined;
}

export class Questionnaire implements IQuestionnaire {
    id!: string;
    name?: string | undefined;
    abbreviation?: string | undefined;
    answers?: Answer[] | undefined;
    questions?: Question[] | undefined;
    questionnaireEstablishments?: QuestionnaireEstablishment[] | undefined;
    questionnaireLegends?: QuestionnaireLegend[] | undefined;
    questionnaireSections?: QuestionnaireSection[] | undefined;

    constructor(data?: IQuestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(Answer.fromJS(item));
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
            if (Array.isArray(_data["questionnaireEstablishments"])) {
                this.questionnaireEstablishments = [] as any;
                for (let item of _data["questionnaireEstablishments"])
                    this.questionnaireEstablishments!.push(QuestionnaireEstablishment.fromJS(item));
            }
            if (Array.isArray(_data["questionnaireLegends"])) {
                this.questionnaireLegends = [] as any;
                for (let item of _data["questionnaireLegends"])
                    this.questionnaireLegends!.push(QuestionnaireLegend.fromJS(item));
            }
            if (Array.isArray(_data["questionnaireSections"])) {
                this.questionnaireSections = [] as any;
                for (let item of _data["questionnaireSections"])
                    this.questionnaireSections!.push(QuestionnaireSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Questionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new Questionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (Array.isArray(this.questionnaireEstablishments)) {
            data["questionnaireEstablishments"] = [];
            for (let item of this.questionnaireEstablishments)
                data["questionnaireEstablishments"].push(item.toJSON());
        }
        if (Array.isArray(this.questionnaireLegends)) {
            data["questionnaireLegends"] = [];
            for (let item of this.questionnaireLegends)
                data["questionnaireLegends"].push(item.toJSON());
        }
        if (Array.isArray(this.questionnaireSections)) {
            data["questionnaireSections"] = [];
            for (let item of this.questionnaireSections)
                data["questionnaireSections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionnaire {
    id: string;
    name?: string | undefined;
    abbreviation?: string | undefined;
    answers?: Answer[] | undefined;
    questions?: Question[] | undefined;
    questionnaireEstablishments?: QuestionnaireEstablishment[] | undefined;
    questionnaireLegends?: QuestionnaireLegend[] | undefined;
    questionnaireSections?: QuestionnaireSection[] | undefined;
}

export class QuestionnaireEstablishment implements IQuestionnaireEstablishment {
    id!: string;
    idQuestionnaire?: string;
    idEstablishment?: string;
    questionnaireEstablishmentQuestionnaire?: Questionnaire;
    questionnaireEstablishmentEstablishment?: Establishment;
    value?: number;

    constructor(data?: IQuestionnaireEstablishment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idQuestionnaire = _data["idQuestionnaire"];
            this.idEstablishment = _data["idEstablishment"];
            this.questionnaireEstablishmentQuestionnaire = _data["questionnaireEstablishmentQuestionnaire"] ? Questionnaire.fromJS(_data["questionnaireEstablishmentQuestionnaire"]) : <any>undefined;
            this.questionnaireEstablishmentEstablishment = _data["questionnaireEstablishmentEstablishment"] ? Establishment.fromJS(_data["questionnaireEstablishmentEstablishment"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): QuestionnaireEstablishment {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireEstablishment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idQuestionnaire"] = this.idQuestionnaire;
        data["idEstablishment"] = this.idEstablishment;
        data["questionnaireEstablishmentQuestionnaire"] = this.questionnaireEstablishmentQuestionnaire ? this.questionnaireEstablishmentQuestionnaire.toJSON() : <any>undefined;
        data["questionnaireEstablishmentEstablishment"] = this.questionnaireEstablishmentEstablishment ? this.questionnaireEstablishmentEstablishment.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IQuestionnaireEstablishment {
    id: string;
    idQuestionnaire?: string;
    idEstablishment?: string;
    questionnaireEstablishmentQuestionnaire?: Questionnaire;
    questionnaireEstablishmentEstablishment?: Establishment;
    value?: number;
}

export class QuestionnaireLegend implements IQuestionnaireLegend {
    id!: string;
    idQuestionnaire?: string;
    name?: string | undefined;
    questionnaireLegendQuestionnaire?: Questionnaire;
    abbrevation?: string | undefined;
    value?: number;
    imageName?: string | undefined;
    questionQuestionnaireLegendQuestionnaireLegends?: QuestionQuestionnaireLegend[] | undefined;

    constructor(data?: IQuestionnaireLegend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idQuestionnaire = _data["idQuestionnaire"];
            this.name = _data["name"];
            this.questionnaireLegendQuestionnaire = _data["questionnaireLegendQuestionnaire"] ? Questionnaire.fromJS(_data["questionnaireLegendQuestionnaire"]) : <any>undefined;
            this.abbrevation = _data["abbrevation"];
            this.value = _data["value"];
            this.imageName = _data["imageName"];
            if (Array.isArray(_data["questionQuestionnaireLegendQuestionnaireLegends"])) {
                this.questionQuestionnaireLegendQuestionnaireLegends = [] as any;
                for (let item of _data["questionQuestionnaireLegendQuestionnaireLegends"])
                    this.questionQuestionnaireLegendQuestionnaireLegends!.push(QuestionQuestionnaireLegend.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionnaireLegend {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireLegend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idQuestionnaire"] = this.idQuestionnaire;
        data["name"] = this.name;
        data["questionnaireLegendQuestionnaire"] = this.questionnaireLegendQuestionnaire ? this.questionnaireLegendQuestionnaire.toJSON() : <any>undefined;
        data["abbrevation"] = this.abbrevation;
        data["value"] = this.value;
        data["imageName"] = this.imageName;
        if (Array.isArray(this.questionQuestionnaireLegendQuestionnaireLegends)) {
            data["questionQuestionnaireLegendQuestionnaireLegends"] = [];
            for (let item of this.questionQuestionnaireLegendQuestionnaireLegends)
                data["questionQuestionnaireLegendQuestionnaireLegends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionnaireLegend {
    id: string;
    idQuestionnaire?: string;
    name?: string | undefined;
    questionnaireLegendQuestionnaire?: Questionnaire;
    abbrevation?: string | undefined;
    value?: number;
    imageName?: string | undefined;
    questionQuestionnaireLegendQuestionnaireLegends?: QuestionQuestionnaireLegend[] | undefined;
}

export class QuestionnaireSection implements IQuestionnaireSection {
    id!: string;
    idQuestionnaire?: string;
    idParentSection?: string | undefined;
    questionnaireSectionQuestionnaire?: Questionnaire;
    questionnaireSectionQuestionnaireSection?: QuestionnaireSection;
    position?: number;
    name?: string | undefined;
    questionQuestionnaireSections?: Question[] | undefined;
    questionnaireSectionQuestionnaireSections?: QuestionnaireSection[] | undefined;

    constructor(data?: IQuestionnaireSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idQuestionnaire = _data["idQuestionnaire"];
            this.idParentSection = _data["idParentSection"];
            this.questionnaireSectionQuestionnaire = _data["questionnaireSectionQuestionnaire"] ? Questionnaire.fromJS(_data["questionnaireSectionQuestionnaire"]) : <any>undefined;
            this.questionnaireSectionQuestionnaireSection = _data["questionnaireSectionQuestionnaireSection"] ? QuestionnaireSection.fromJS(_data["questionnaireSectionQuestionnaireSection"]) : <any>undefined;
            this.position = _data["position"];
            this.name = _data["name"];
            if (Array.isArray(_data["questionQuestionnaireSections"])) {
                this.questionQuestionnaireSections = [] as any;
                for (let item of _data["questionQuestionnaireSections"])
                    this.questionQuestionnaireSections!.push(Question.fromJS(item));
            }
            if (Array.isArray(_data["questionnaireSectionQuestionnaireSections"])) {
                this.questionnaireSectionQuestionnaireSections = [] as any;
                for (let item of _data["questionnaireSectionQuestionnaireSections"])
                    this.questionnaireSectionQuestionnaireSections!.push(QuestionnaireSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionnaireSection {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idQuestionnaire"] = this.idQuestionnaire;
        data["idParentSection"] = this.idParentSection;
        data["questionnaireSectionQuestionnaire"] = this.questionnaireSectionQuestionnaire ? this.questionnaireSectionQuestionnaire.toJSON() : <any>undefined;
        data["questionnaireSectionQuestionnaireSection"] = this.questionnaireSectionQuestionnaireSection ? this.questionnaireSectionQuestionnaireSection.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["name"] = this.name;
        if (Array.isArray(this.questionQuestionnaireSections)) {
            data["questionQuestionnaireSections"] = [];
            for (let item of this.questionQuestionnaireSections)
                data["questionQuestionnaireSections"].push(item.toJSON());
        }
        if (Array.isArray(this.questionnaireSectionQuestionnaireSections)) {
            data["questionnaireSectionQuestionnaireSections"] = [];
            for (let item of this.questionnaireSectionQuestionnaireSections)
                data["questionnaireSectionQuestionnaireSections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuestionnaireSection {
    id: string;
    idQuestionnaire?: string;
    idParentSection?: string | undefined;
    questionnaireSectionQuestionnaire?: Questionnaire;
    questionnaireSectionQuestionnaireSection?: QuestionnaireSection;
    position?: number;
    name?: string | undefined;
    questionQuestionnaireSections?: Question[] | undefined;
    questionnaireSectionQuestionnaireSections?: QuestionnaireSection[] | undefined;
}

export class SustainabilityMemory implements ISustainabilityMemory {
    id!: string;
    idEstablishment?: string;
    sustainabilityMemoryEstablishment?: Establishment;
    ourHotel?: string | undefined;
    mision?: string | undefined;
    technicalCharacteristics?: string | undefined;
    employeeInfo?: string | undefined;
    gobernance?: string | undefined;
    bigGoals?: string | undefined;
    environmentalSustainability?: string | undefined;
    emissions?: string | undefined;
    energy?: string | undefined;
    water?: string | undefined;
    biodiversity?: string | undefined;
    circularEconomy?: string | undefined;
    socialSustainability?: string | undefined;
    teamManagement?: string | undefined;
    educationSensibility?: string | undefined;
    comunityCommitment?: string | undefined;
    supplyChain?: string | undefined;
    economicSustainability?: string | undefined;
    odssContribution?: string | undefined;
    certifications?: string | undefined;
    communication?: string | undefined;
    initiatives?: string | undefined;
    resume?: string | undefined;
    intro?: string | undefined;

    constructor(data?: ISustainabilityMemory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idEstablishment = _data["idEstablishment"];
            this.sustainabilityMemoryEstablishment = _data["sustainabilityMemoryEstablishment"] ? Establishment.fromJS(_data["sustainabilityMemoryEstablishment"]) : <any>undefined;
            this.ourHotel = _data["ourHotel"];
            this.mision = _data["mision"];
            this.technicalCharacteristics = _data["technicalCharacteristics"];
            this.employeeInfo = _data["employeeInfo"];
            this.gobernance = _data["gobernance"];
            this.bigGoals = _data["bigGoals"];
            this.environmentalSustainability = _data["environmentalSustainability"];
            this.emissions = _data["emissions"];
            this.energy = _data["energy"];
            this.water = _data["water"];
            this.biodiversity = _data["biodiversity"];
            this.circularEconomy = _data["circularEconomy"];
            this.socialSustainability = _data["socialSustainability"];
            this.teamManagement = _data["teamManagement"];
            this.educationSensibility = _data["educationSensibility"];
            this.comunityCommitment = _data["comunityCommitment"];
            this.supplyChain = _data["supplyChain"];
            this.economicSustainability = _data["economicSustainability"];
            this.odssContribution = _data["odssContribution"];
            this.certifications = _data["certifications"];
            this.communication = _data["communication"];
            this.initiatives = _data["initiatives"];
            this.resume = _data["resume"];
            this.intro = _data["intro"];
        }
    }

    static fromJS(data: any): SustainabilityMemory {
        data = typeof data === 'object' ? data : {};
        let result = new SustainabilityMemory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idEstablishment"] = this.idEstablishment;
        data["sustainabilityMemoryEstablishment"] = this.sustainabilityMemoryEstablishment ? this.sustainabilityMemoryEstablishment.toJSON() : <any>undefined;
        data["ourHotel"] = this.ourHotel;
        data["mision"] = this.mision;
        data["technicalCharacteristics"] = this.technicalCharacteristics;
        data["employeeInfo"] = this.employeeInfo;
        data["gobernance"] = this.gobernance;
        data["bigGoals"] = this.bigGoals;
        data["environmentalSustainability"] = this.environmentalSustainability;
        data["emissions"] = this.emissions;
        data["energy"] = this.energy;
        data["water"] = this.water;
        data["biodiversity"] = this.biodiversity;
        data["circularEconomy"] = this.circularEconomy;
        data["socialSustainability"] = this.socialSustainability;
        data["teamManagement"] = this.teamManagement;
        data["educationSensibility"] = this.educationSensibility;
        data["comunityCommitment"] = this.comunityCommitment;
        data["supplyChain"] = this.supplyChain;
        data["economicSustainability"] = this.economicSustainability;
        data["odssContribution"] = this.odssContribution;
        data["certifications"] = this.certifications;
        data["communication"] = this.communication;
        data["initiatives"] = this.initiatives;
        data["resume"] = this.resume;
        data["intro"] = this.intro;
        return data;
    }
}

export interface ISustainabilityMemory {
    id: string;
    idEstablishment?: string;
    sustainabilityMemoryEstablishment?: Establishment;
    ourHotel?: string | undefined;
    mision?: string | undefined;
    technicalCharacteristics?: string | undefined;
    employeeInfo?: string | undefined;
    gobernance?: string | undefined;
    bigGoals?: string | undefined;
    environmentalSustainability?: string | undefined;
    emissions?: string | undefined;
    energy?: string | undefined;
    water?: string | undefined;
    biodiversity?: string | undefined;
    circularEconomy?: string | undefined;
    socialSustainability?: string | undefined;
    teamManagement?: string | undefined;
    educationSensibility?: string | undefined;
    comunityCommitment?: string | undefined;
    supplyChain?: string | undefined;
    economicSustainability?: string | undefined;
    odssContribution?: string | undefined;
    certifications?: string | undefined;
    communication?: string | undefined;
    initiatives?: string | undefined;
    resume?: string | undefined;
    intro?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}